import { useEffect, useState } from "react";
import { CreatePackages, getCreatedPackages, getCurrency, getPackagesName } from "../../../services/apis/EventMangement/CreateEventApi";
import { toast, ToastContainer } from "react-toastify";
import BtnLoader from "../Loader/BtnLoader";
import Swal from "sweetalert2";

const PackageDetails = ({ eventId, setTabValue }) => {
    const [inputData, setInputData] = useState({
        package_type: "",
        currency: "",
        package_amount: "",
        package_date: "",
        package_time: "",
        quantity: "",
        package_description: "",
        discount_code: "",
        discount_percentage: "",
        discount_amount: "",
        discount_expiry_date: ""
    });

    const [packages, setPackages] = useState([]);
    const [currency, setCurrency] = useState([])
    const [btnLoading,setBtnLoading]=useState(false);
    const [createdPackages, setCreatedPackages] = useState([]);
    const [errors, setErrors] = useState({});

    console.log("createdPackages",createdPackages)

    // Handle input changes
    const handlePackages = (e) => {
        const { name, value } = e.target;

        setInputData({
            ...inputData,
            [name]: value,
        });

    };

    const validate = () => {
        const newErrors = {};
        if (!inputData?.package_type?.trim())
          newErrors.package_type = "Ticket Category Name is required.";
    
        if (!inputData?.package_amount?.trim())
          newErrors.package_amount = "Amount is required.";
    
        if (!inputData?.quantity ?.trim())
          newErrors.quantity = "Quantity is required.";
    
        if (!inputData?.package_description) newErrors.package_description = "Description is required.";
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const getTicketList = async () => {
        try {
            const response = await getCreatedPackages(eventId);
            setCreatedPackages(response?.data?.data)
        } catch (error) {
            console.log(error.message);
        }
    }

    useEffect(() => {
        if (eventId) {
            getTicketList();
        }
    }, [eventId])

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            // setCreatedPackages((prevPackages) => [...prevPackages, inputData]);
            setErrors({});
            setBtnLoading(true);
            try {
                const response = await CreatePackages(eventId, inputData);
                // console.log(response, 'response-------------')
                if (response?.data?.success) {
                    Swal.fire({
                      icon: "success",
                      title: "Event",
                      text: response?.data?.message,
                    });

                    toast.success(response?.data?.message)
                    getTicketList();
                    setInputData({
                      package_type: "",
                      currency: "",
                      package_amount: "",
                      package_date: "",
                      package_time: "",
                      quantity: "",
                      package_description: "",
                      discount_code: "",
                      discount_percentage: "",
                      discount_amount: "",
                      discount_expiry_date: ""
                    });
                }
            } catch (error) {
                console.error("Error while submitting the form:", error);
                toast.error(error?.response?.data?.message);
            }finally{
                setBtnLoading(false);
            }
        } else {
            console.log("Form contains errors:", errors);
        }
    };

    const handleDeletePackage = (id) => {
        console.log("Delete package with ID:", id);
    };

    const handleEditPackage = (id) => {
        console.log("Edit package with ID:", id);
    };


    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await getPackagesName();
                setPackages(response?.data?.data);
            } catch (error) {
                console.log(error.message);
            }


            try {
                const response = await getCurrency();
                setCurrency(response?.data?.data);
            } catch (error) {
                console.log(error.message);
            }

        };

        fetchData();
    }, [])



    return (
        <>
            <ToastContainer />
            <div className="container-fluid my-0">
                <div className="row col-12">
                    <div className="col-8">
                        <form onSubmit={handleSubmit}>
                            <div className="card profile-card card-bx">
                                <div className="card-header">
                                    <h6 className="card-title">Ticket Types</h6>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label className="col-sm-6 col-form-label">Ticket Category Name<span className="asterisk">*</span></label>
                                            <select
                                                className="form-control"
                                                name="package_type"
                                                value={inputData?.package_type}
                                                onChange={handlePackages}>
                                                <option value="">Select Package</option>
                                                {packages?.map((value) => (
                                                    <option key={value._id} value={value._id}>{value?.name}</option>
                                                ))}
                                            </select>
                                            {errors.package_type && <small className="text-danger">{errors.package_type}</small>}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="col-sm-6 col-form-label">Price<span className="asterisk">*</span></label>
                                            <div className="input-group">
                                                <select
                                                    name="currency"
                                                    value={inputData.currency}
                                                    onChange={handlePackages}
                                                    className="form-select">
                                                    <option value="">Select Currency</option>
                                                    {currency.map((value) => (
                                                        <option key={value._id} value={value._id}>{value?.code}</option>
                                                    ))}
                                                </select>

                                                <input
                                                    name="package_amount"
                                                    value={inputData.package_amount || ""}
                                                    onChange={handlePackages}
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Amount"
                                                />
                                            </div>
                                            {errors.package_amount && <small className="text-danger">{errors.package_amount}</small>}
                                        </div>
                                    </div>

                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label className="col-sm-6 col-form-label">Quantity Available<span className="asterisk">*</span></label>
                                            <input
                                                name="quantity"
                                                value={inputData.quantity || ""}
                                                onChange={handlePackages}
                                                type="number"
                                                className="form-control"
                                                placeholder="Qty"
                                            />
                                            {errors.quantity && <small className="text-danger">{errors.quantity}</small>}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="col-sm-6 col-form-label">Booking Deadline</label>
                                            <div className="input-group">
                                                <input
                                                    name="package_date"
                                                    value={inputData.package_date || ""}
                                                    onChange={handlePackages}
                                                    type="date"
                                                    className="form-control"
                                                />
                                                <input
                                                    name="package_time"
                                                    value={inputData.package_time || ""}
                                                    onChange={handlePackages}
                                                    type="time"
                                                    className="form-control"
                                                />
                                            </div>
                                            {errors.package_time && <small className="text-danger">{errors.package_time}</small>}
                                        </div>
                                    </div>

                                    <div className="mb-3 row">
                                        <div className="col-md-12">
                                            <label className="col-sm-3 col-form-label">Description<span className="asterisk">*</span></label>
                                            <textarea
                                                name="package_description"
                                                value={inputData.package_description || ""}
                                                onChange={handlePackages}
                                                className="form-control"
                                                rows="6"
                                                placeholder="Detailed description of the package."
                                                maxLength={500}
                                            ></textarea>
                                            {errors.package_description && <small className="text-danger">{errors.package_description}</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card profile-card card-bx">
                                <div className="card-header">
                                    <h6 className="card-title">Discount Code (optional)</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-5">
                                            <label className="col-sm-6 col-form-label">Code</label>
                                            <input
                                                name="discount_code"
                                                value={inputData.discount_code || ""}
                                                onChange={handlePackages}
                                                type="text"
                                                className="form-control"
                                                placeholder="Ex: Code"
                                                maxLength={50}
                                            />
                                            {errors.discount_code && <small className="text-danger">{errors.discount_code}</small>}
                                        </div>

                                        <div className="col-md-7">
                                            <label className="col-sm-7 col-form-label">Discount Percentage or Fixed Amount</label>
                                            <div className="input-group">
                                                <input
                                                    name="discount_percentage"
                                                    value={inputData.discount_percentage || ""}
                                                    onChange={handlePackages}
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Discount Percentage"
                                                />

                                                <input
                                                    name="discount_amount"
                                                    value={inputData.discount_amount || ""}
                                                    onChange={handlePackages}
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Fixed Amount"
                                                />
                                            </div>
                                            {errors.discount_percentage && <small className="text-danger">{errors.discount_percentage}</small>}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-5">
                                            <label className="col-sm-6 col-form-label">Expiry Date</label>
                                            <input
                                                name="discount_expiry_date"
                                                value={inputData.discount_expiry_date || ""}
                                                onChange={handlePackages}
                                                type="date"
                                                className="form-control"
                                            />
                                            {errors.discount_expiry_date && <small className="text-danger">{errors.discount_expiry_date}</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-4">
                                <div className="">
                                    <button className="btn btn-outline-primary" type="button"
                                     onClick={()=>setTabValue("Media-Hub")}
                                    >Skip</button>
                                </div>
                                <div className="">
                                    <button className="btn btn-primary" type="submit">{btnLoading && <BtnLoader/>}Save and continue</button>
                                </div>
                            </div>
                        </form>

                    </div>

                    <div className="col-4">
                        {createdPackages.length > 0 && (
                            <div className="p-2">
                                {createdPackages?.map((val, index) => (
                                    <div
                                        key={index}
                                        className="create-event-save-btn d-flex align-items-center gap-2 py-2 border border-2 p-3 mt-2 rounded">
                                        <div
                                            className="donation-package-input"
                                            style={{ height: "70px", width: "100%" }}>
                                            <span className="package-title-text">{val.package_name}</span>
                                            <br />
                                            <span className="select-pack-text">{val?.currency} {val.amount}</span>

                                            <p>{val?.description}</p>
                                        </div>
                                        <button
                                            className="p-1"
                                            onClick={() => handleEditPackage(index)}
                                            title="Edit">
                                            Edit
                                        </button>
                                        <button
                                            className="p-1"
                                            onClick={() => handleDeletePackage(index)}
                                            title="Delete">
                                            Delete
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PackageDetails;
